import { ref, onMounted, onUnmounted } from 'vue'
import { api, endpoints } from '../services/api.js'

const POLL_INTERVAL = 30000

// Shared module-level state (singleton across all components)
const unreadCount = ref(0)
const unreadDetails = ref([])

let timer = null
let mountCount = 0

async function fetchUnread() {
  try {
    const data = await api.get(endpoints.messagesFormateur.unreadCount())
    unreadCount.value = data?.count ?? 0
    unreadDetails.value = data?.details ?? []
  } catch {
    // Silent fail — sidebar should not block on errors
  }
}

/**
 * Shared composable for unread messages state.
 * Uses singleton pattern: all components share the same refs and single polling timer.
 * Call refreshUnread() from anywhere to immediately update the sidebar badge.
 */
export function useUnreadMessages() {
  onMounted(() => {
    mountCount++
    if (mountCount === 1) {
      fetchUnread()
      timer = setInterval(fetchUnread, POLL_INTERVAL)
    }
  })

  onUnmounted(() => {
    mountCount--
    if (mountCount === 0 && timer) {
      clearInterval(timer)
      timer = null
    }
  })

  return {
    unreadCount,
    unreadDetails,
    refreshUnread: fetchUnread,
  }
}

/**
 * Standalone refresh function — can be called from any composable
 * without needing lifecycle hooks (e.g. useMessagerieFormateurs).
 */
export const refreshUnread = fetchUnread
